import { CartLinesUpdateEvent } from '@shopify/events';

class ToffeeMixMatch extends HTMLElement {
  connectedCallback() {
    if (this.initialized) {
      window.addEventListener('pageshow', this.pageShowHandler);
      this.updateChoices();
      return;
    }
    this.initialized = true;
    this.form = this.querySelector('form');
    this.button = this.querySelector('button');
    this.status = this.querySelector('[role="status"]');
    this.selects = [...this.querySelectorAll('select')];
    this.buttonText = this.button.textContent;
    this.selects.forEach(select => select.addEventListener('change', () => this.updateChoices()));
    this.form.addEventListener('submit', event => this.addPair(event));
    this.pageShowHandler = () => requestAnimationFrame(() => this.updateChoices());
    window.addEventListener('pageshow', this.pageShowHandler);
    this.updateChoices();
    requestAnimationFrame(() => this.updateChoices());
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this.pageShowHandler);
  }

  updateChoices() {
    this.selects.forEach(select => {
      const option = select.selectedOptions[0];
      const image = select.parentElement.querySelector('img');
      if (option) { image.src = option.dataset.image; image.alt = option.dataset.title; }
    });
    this.button.disabled = this.selects.some(select => !select.selectedOptions[0] || select.selectedOptions[0].disabled);
    this.status.textContent = '';
    this.status.removeAttribute('data-error');
  }

  async addPair(event) {
    event.preventDefault();
    if (this.busy || this.button.disabled) return;
    this.busy = true;
    this.button.disabled = true;
    this.button.textContent = this.dataset.adding;
    this.setAttribute('aria-busy', 'true');
    this.status.textContent = '';
    this.status.removeAttribute('data-error');
    const root = window.Shopify.routes.root;
    const grouped = new Map();
    this.selects.forEach(select => {
      const id = Number(select.value);
      grouped.set(id, (grouped.get(id) || 0) + 1);
    });
    const items = [...grouped].map(([id, quantity]) => ({ id, quantity }));
    let deferred;
    try {
      const beforeResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!beforeResponse.ok) throw new Error(this.dataset.error);
      const before = await beforeResponse.json();
      for (const item of items) {
        const option = this.selects.flatMap(select => [...select.options]).find(option => Number(option.value) === item.id);
        const stock = Number(option.dataset.stock);
        const inCart = before.items.filter(line => line.variant_id === item.id).reduce((sum, line) => sum + line.quantity, 0);
        if (stock >= 0 && inCart + item.quantity > stock) throw new Error(this.dataset.stockError);
      }
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
      deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity })), promise: deferred.promise }));
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }) });
      const added = await response.json();
      if (!response.ok || added.status) throw new Error(added.description || this.dataset.error);
      const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) { window.location.assign(root + 'cart'); return; }
      const cart = await cartResponse.json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'toffee-mix-match', sourceId: this.id || 'toffee-mix-match', itemCount: 2, sections: added.sections, didError: false } });
      this.status.textContent = this.dataset.added;
      if (!sections.length) window.location.assign(root + 'cart');
    } catch (error) {
      if (deferred) { deferred.promise.catch(() => {}); deferred.reject(error); }
      this.status.textContent = error.message || this.dataset.error;
      this.status.setAttribute('data-error', '');
    } finally {
      this.busy = false;
      this.button.disabled = false;
      this.button.textContent = this.buttonText;
      this.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('toffee-mix-match')) customElements.define('toffee-mix-match', ToffeeMixMatch);
